import { COLORS3 } from '@zola/zola-ui/src/styles/emotion';
import type {
  NextGridImageItem,
  NextGridTextItem,
} from 'components/PreauthV3/NextLpGrid/NextLpGrid';

const Grid1Foreground =
  '/static-preauth/images/WeddingRegistryLP/V3/Grid/Desktop/Grid1_foreground.png';
const Grid1BackgroundDesktopWebp =
  '/static-preauth/images/WeddingRegistryLP/V3/Grid/Desktop/Grid1_background.webp';

const Grid2ForegroundDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Grid/Desktop/Grid2_foreground.png';

const Grid2BackgroundDesktopWebp =
  '/static-preauth/images/WeddingRegistryLP/V3/Grid/Desktop/Grid2_background.webp';

const Grid3ForegroundDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Grid/Desktop/Grid3_foreground.png';

const Grid4BackgroundDesktopWebp =
  '/static-preauth/images/WeddingRegistryLP/V3/Grid/Desktop/Grid4_background.webp';

const Grid5ForegroundDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Grid/Desktop/Grid5_foreground.png';

const Grid5BackgroundDesktopWebp =
  '/static-preauth/images/WeddingRegistryLP/V3/Grid/Desktop/Grid5_background.webp';

const gridImage1: NextGridImageItem = {
  imageProps: {
    backgroundImg: {
      alt: 'White Le Creuset dutch oven with gold hardware.',
      src: Grid1BackgroundDesktopWebp,
    },
    foregroundImg: {
      src: Grid1Foreground,
      alt: 'Only on Zola',
    },
    priority: false,
  },
};

const gridImage2: NextGridImageItem = {
  imageProps: {
    backgroundImg: {
      alt: 'Screenshot of a chat with a wedding expert on how to check if a couple received their gift.',
      src: Grid2BackgroundDesktopWebp,
    },
    foregroundImg: {
      src: Grid2ForegroundDesktop,
      alt: '',
    },
    priority: false,
  },
};

const gridImage3: NextGridImageItem = {
  imageProps: {
    bgColor: COLORS3.BAY_100,
    foregroundImg: {
      src: Grid3ForegroundDesktop,
      alt: '',
    },
    priority: false,
  },
};

const gridImage4: NextGridImageItem = {
  imageProps: {
    backgroundImg: {
      alt: '',
      src: Grid4BackgroundDesktopWebp,
    },
    priority: false,
  },
};

const gridImage5: NextGridImageItem = {
  imageProps: {
    backgroundImg: {
      alt: '',
      src: Grid5BackgroundDesktopWebp,
    },
    foregroundImg: {
      src: Grid5ForegroundDesktop,
      alt: '',
    },
    priority: false,
  },
};

const GET_STARTED_TEXT = 'Get started';
const ONBOARD_HREF = '/onboard/new';

const oneRegistryEndlessPossibilities: NextGridTextItem = {
  highlightTitle: (
    <>
      <strong>One registry</strong> endless possibilities
    </>
  ),
  href: ONBOARD_HREF,
  linkText: GET_STARTED_TEXT,
};

const shopFromYourWebsite: NextGridTextItem = {
  highlightTitle: (
    <>
      <strong>Shop from your website</strong> (no annoying link-outs)
    </>
  ),
  href: ONBOARD_HREF,
  linkText: GET_STARTED_TEXT,
};

const oneOnOneSupport: NextGridTextItem = {
  highlightTitle: (
    <>
      <strong>One-on-one support</strong> for you and guests
    </>
  ),
  href: ONBOARD_HREF,
  linkText: GET_STARTED_TEXT,
};

const zolaExclusives: NextGridTextItem = {
  highlightTitle: (
    <>
      <strong>Zola exclusives</strong> and curated collections
    </>
  ),
  href: ONBOARD_HREF,
  linkText: GET_STARTED_TEXT,
};

export const desktopGridItems: (NextGridImageItem | NextGridTextItem)[] = [
  oneRegistryEndlessPossibilities,
  gridImage1,
  shopFromYourWebsite,
  gridImage2,
  oneOnOneSupport,
  gridImage3,
  zolaExclusives,
  gridImage4,
  gridImage5,
];

export const mobileGridItems: (NextGridImageItem | NextGridTextItem)[] = [
  oneRegistryEndlessPossibilities,
  gridImage1,
  gridImage2,
  oneOnOneSupport,
  zolaExclusives,
  gridImage5,
];
